
<div class="sidebar-main-menu lgSubMenu   addedLeft" style="background-size: 200%; background-repeat: no-repeat;" *ngIf="!loadingSample && demographData.length > 0">

    <common-data [commonid]="sendpatientId"></common-data>
    <div class="encounter-profile-list text-mute">
        <h5 class="menu-title text-primary pl-0 pt-0">Lab Details <span *ngIf="!loadingSample && demographData.length > 0">({{demographData[0].testName}})</span></h5>
        <ul style="line-height:30px;">
            <li>
                <div class="text-truncate">
                    <i class="mdi mdi-doctor  text-primary mr-1"></i><span class="font-weight-bolder">Dr.</span>
                    <span class="font-14 mt-1x" [textContent]="demographData[0].doctorName"></span>
                </div>
            </li>
            <li>
                <i class="mdi mdi-numeric text-primary mr-1"></i><span class="font-weight-bolder">Req No :</span>
                <span class="font-13 mt-1x" [textContent]="demographData[0].requisitionNumber"></span>
            </li>
            <li class="d-flex" style="line-height:1.4;">
                <i class="mdi mdi-account text-primary mr-1"></i> <span><span class="font-14 mt-1x break-all" [textContent]="demographData[0].sampleCollectedByName +'&nbsp;'"></span><span _ngcontent-tjk-c1="" class="badge bg-primary text-white font-weight-lighter" style="padding:3px;">Collected</span></span>
            </li>
            <li class="ml-4" style="list-style:circle;">
                <i class="mdi mdi-calendar text-primary mr-1"></i>
                <span class="font-13 mt-1x" [textContent]="demographData[0].collectionDate | date:'dd/MM/yyyy'"></span>
            </li>
            <li class="ml-4" style="list-style:circle;">
                <i class="mdi mdi-clock text-primary mr-1"></i>
                <span class="font-13 mt-1x" [textContent]="demographData[0].collectionDate | date:'hh:mm a'"></span>
            </li>
            <li class="d-flex" style="line-height:1.4;">
                <i class="mdi mdi-account text-primary mr-1"></i> <span><span class="font-14 mt-1x break-all" [textContent]="demographData[0].recievedByName +'&nbsp;'"></span><span class="badge bg-primary text-white font-weight-lighter" style="padding:3px;">Received</span></span>
            </li>
            <li class="ml-4" style="list-style:circle;">
                <i class="mdi mdi-calendar text-primary mr-1"></i>
                <span class="font-13 mt-1x" [textContent]="demographData[0].receivedDate | date:'dd/MM/yyyy'"></span>
            </li>
            <li class="ml-4" style="list-style:circle;">
                <i class="mdi mdi-clock text-primary mr-1"></i>
                <span class="font-13 mt-1x" [textContent]="demographData[0].receivedDate | date:'hh:mm a'"></span>
            </li>
        </ul>
    </div>
</div>


<div [ngClass]="{'margin-left-220':!loadingSample && demographData.length > 0}" *ngIf="!loadingSample && demographData.length > 0">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right">
                            <button *ngIf="isHaveParameters && page.userAccount.roleId != 3" class="btn btn-sm btn-outline-danger"
                                    (click)="OpenReasonView(templateReason)">
                                Clear Parameters
                            </button>
                            <button *ngIf="!isHaveParameters && page.userAccount.roleId != 3" class="btn btn-sm btn-outline-danger"
                                    (click)="onFetchInputParameters()">
                                Clear Parameters
                            </button>
                            <button class="btn btn-sm btn-outline-primary" (click)="onViewPastLabReports(templateShowPastReports)">
                                <div ngbTooltip="Past Lab Results">Past Lab Results</div>
                            </button>
                            <button *ngIf="!showReport" class="btn btn-sm btn-outline-primary" (click)="onOpenModalMultiple(templateMultipleUploadDocument)">
                                <div>Upload Document</div>
                            </button>
                            <button class="btn btn-sm btn-outline-primary" *ngIf="showReport" (click)="onViewDocument(templateUploadDocument)">
                                Upload & View Document
                            </button>
                            <button *menuButton="'lab_techview_parameter_allresult'" class="btn btn-sm btn-outline-primary" (click)="viewPreviousResultsAdded(showPreviousResults)">
                                All Results
                            </button>
                            <span *menuButton="'lab_techview_parameter_assign_doctor'">
                                <button class="btn btn-sm btn-outline-primary" (click)="selectDoctor(assignDoctor)" *ngIf=" demographData && demographData[0].assignDoctorRequired">
                                    Assign Doctor
                                </button>
                            </span>
                            <button *menuButton="'lab_techview_parameter_viewreport'" class="btn btn-sm btn-outline-primary" (click)="onViewReportNew(templateLabReport)">
                                <i class="mdi mdi-text-box mr-1"></i> View Interim Report
                            </button>
                            <button class="btn btn-sm btn-outline-danger" (click)="onCloseModel()">
                                <i class="mdi mdi-close mr-1"></i> Close
                            </button>
                        </div>
                        <h4 class="page-title">
                            <i class="mdi mdi-flask-plus mr-1"></i> Verify Report
                        </h4>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row p-2" *ngIf="loading">
                        <div class="col-12">
                            <div class="d-flex align-items-center">
                                <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
                                <span class="ml-2">Please wait while loading ...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row p-1" *ngIf="!loading && parameters === null">
                        <div class="col-12 mh-300">
                            <no-data [applied]="false" [title]="'parameter'"></no-data>
                        </div>
                    </div>
                    <div *ngIf="!loading && parameters !== null">
                        <div class="row">
                            <div class="col-12" *ngFor="let template of reports.templates;index as t;">
                                <div class="card mb-1 shadow-none border bg-pattern">
                                    <div class="p-2">
                                        <div class="row align-items-center">
                                            <div class="col-auto">
                                                <div class="avatar-sm">
                                                    <span class="avatar-title badge-soft-primary text-primary rounded">
                                                        <i class="mdi mdi-link-plus mdi-18px"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col ps-0">
                                                <a href="javascript:void(0);" class="font-14 fw-bold">{{template.templateName}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" *ngIf="template.parameters && template.parameters.length > 0">
                                        <div class="headingStyle">
                                            <div class="trapezium font-weight-semibold text-white">
                                                <span class="p-1"><i class="mdi mdi-chart-gantt me-1"></i> <span>Direct Parameters</span></span>
                                            </div>
                                        </div>
                                        <div class="card p-2">
                                            <div class="row" *ngFor="let parameter of template.parameters;index as p;">
                                                <div class="row col-12" *ngIf="parameter.type === 'Regular'">
                                                    <div class="col-6">
                                                        <label class="mb-0"> {{parameter.parameterName}} <code *ngIf="isValidation" >*</code></label>
                                                        <div class="form-group d-flex col-12 leftmargin-25">
                                                            <div class="col-11">
                                                                <input *ngIf="parameter.referenceOutput === 'numeric'" [ngStyle]="{'color': parameter.isBold ? 'red':'black' }" class="form-control" placeholder="Enter {{parameter.displayName}}" (keyup)="onChange()" [(ngModel)]="parameter.observedValue" (input)="changeTextColor(parameter)" type="text" />
                                                                <textarea rows="2" *ngIf="parameter.referenceOutput === 'text'" class="form-control" placeholder="Enter {{parameter.displayName}}" (keyup)="onChange()" [(ngModel)]="parameter.observedValue"></textarea>
                                                                <select *ngIf="parameter.referenceOutput === 'selection'" class="form-control custom-select form-control-sm" (change)="onChange()" autocomplete="nope" [(ngModel)]="parameter.observedValue">
                                                                    <option [ngValue]="null">None</option>
                                                                    <option *ngFor="let item of parameter.allParameterDetail" [textContent]="item.selectionName" [ngValue]="item.selectionName"></option>
                                                                </select>
                                                            </div>
                                                            <div class="col-1 mt-1">
                                                                <h5 class="mt-0 mb-0 text-danger" *ngIf="parameter.labParameterDetailId">{{parameter.showText}}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label class="mb-0"> Range<code *ngIf="isValidation">*</code></label>
                                                            <div class="p-0 mb-0" *ngIf="parameter.referenceOutput === 'numeric' && parameter.type === 'Regular'">
                                                             
                                                                <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId">
                                                                    {{parameter.selected.minValue}}-{{parameter.selected.maxValue}}&nbsp;
                                                                    <i class="fe-edit" style="cursor: pointer;" (click)="onOpenForParameterSelection(templateReferenceRange,parameter)"></i>
                                                                </h5>
                                                                <div *ngIf="!parameter.labParameterDetailId">
                                                                    <button type="button" class="btn btn-sm waves-effect waves-light"
                                                                            (click)="onOpenForParameterSelection(templateReferenceRange,parameter)">
                                                                        Choose
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="p-0 mb-0" *ngIf="parameter.referenceOutput != 'numeric' && parameter.type === 'Regular'">
                                                                <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId" [innerHTML]="parameter.text ||'-'">
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-2">
                                                        <div class="form-group">
                                                            <label class="mb-0"> Unit <code *ngIf="isValidation">*</code></label>
                                                            <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId" [textContent]="parameter.selected.unitName || '--'">
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-12" *ngIf="parameter.type != 'Regular'">
                                                    <div class="col-12 d-flex">
                                                        <div class="form-group col-6">
                                                            <label class="mb-0 text-capitalize text-primary"> {{parameter.parameterName}}</label>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="form-group mb-0 position-relative">
                                                                <ng-select class="ng-select-sm" [items]="labAntibiotics" #ngSelectOption
                                                                           bindLabel="antibioticName"
                                                                           bindValue="antibioticName"
                                                                           typeToSearchText="Search Antibiotic"
                                                                           placeholder="Enter Antibiotic name"
                                                                           (change)="onClickMicroParameter($event ,t,p)" (click)="ngSelectOption.handleClearClick()">
                                                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                                                        No parameter found<span *ngIf="searchTerm"> for '{{searchTerm}}'</span>.
                                                                    </ng-template>
                                                                    <ng-template ng-option-tmp let-item="item" let-i="index">
                                                                        <h5 class="mb-1 mt-0 font-weight-normal" [textContent]="item.antibioticName"></h5>
                                                                    </ng-template>
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row col-12" *ngFor="let antibiotic of parameter.antibiotics;index as j;">
                                                        <div class="row form-group col-12">
                                                            <label class="mb-0 col-4"> {{antibiotic.antibioticName}}</label>
                                                            <select (change)="onChange()" class="form-control custom-select form-control-sm col-4" autocomplete="nope" [(ngModel)]="antibiotic.observedValue">
                                                                <option [ngValue]="null">None</option>
                                                                <option *ngFor="let item of labAntibioticsResultTypes" [textContent]="item.name" [ngValue]="item.name"></option>
                                                            </select>
                                                            <div *ngIf="!antibiotic.labParameterobservedValueId">
                                                                <button type="button" class="btn btn-sm waves-effect waves-light"
                                                                        (click)="removeAntibiotic(parameter,j , t , p)">
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" *ngFor="let component of template.components;index as c;">
                                        <div class="headingStyle">
                                            <div class="trapezium font-weight-semibold text-white">
                                                <span class="p-1"><i class="mdi mdi-chart-gantt me-1"></i> <span [textContent]="component.componentName"></span></span>
                                            </div>
                                        </div>
                                        <div class="card p-2">
                                            <div class="row" *ngFor="let parameter of component.parameters;index as p;">
                                                <div class="row col-12" *ngIf="parameter.type === 'Regular'">
                                                    <div class="col-6">
                                                        <label class="mb-0"> {{parameter.parameterName}} <code *ngIf="isValidation" >*</code></label>
                                                        <div class="form-group d-flex col-12 leftmargin-25">
                                                            <div class="col-11">
                                                                <input *ngIf="parameter.referenceOutput === 'numeric'" class="form-control" (keyup)="onChange()" placeholder="Enter {{parameter.displayName}}" type="text" [(ngModel)]="parameter.observedValue" [ngStyle]="{'color': parameter.isBold ? 'red':'black'}" (input)="changeTextColor(parameter)" />
                                                                <textarea rows="2" *ngIf="parameter.referenceOutput === 'text'" (keyup)="onChange()" class="form-control" placeholder="Enter {{parameter.displayName}}" [(ngModel)]="parameter.observedValue"></textarea>
                                                                <select *ngIf="parameter.referenceOutput === 'selection'" class="form-control custom-select form-control-sm" autocomplete="nope" [(ngModel)]="parameter.observedValue">
                                                                    <option [ngValue]="null">None</option>
                                                                    <option *ngFor="let item of parameter.allParameterDetail" [textContent]="item.selectionName" [ngValue]="item.selectionName"></option>
                                                                </select>
                                                            </div>
                                                            <div class="col-1 mt-1">
                                                                <h5 class="mt-0 mb-0 text-danger" *ngIf="parameter.labParameterDetailId">{{parameter.showText}}</h5>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label class="mb-0"> Range<code *ngIf="isValidation">*</code></label>
                                                            <div class="p-0 mb-0" *ngIf="parameter.referenceOutput === 'numeric' && parameter.type === 'Regular'">
                                                                <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId">

                                                                    {{parameter.selected.minValue}}-{{parameter.selected.maxValue}}&nbsp;
                                                                    <i class="fe-edit" style="cursor: pointer;" (click)="onOpenForParameterSelection(templateReferenceRange,parameter)"></i>
                                                                </h5>
                                                                <div *ngIf="!parameter.labParameterDetailId">
                                                                    <button type="button" class="btn btn-sm waves-effect waves-light"
                                                                            (click)="onOpenForParameterSelection(templateReferenceRange,parameter)">
                                                                        Choose
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="p-0 mb-0" *ngIf="parameter.referenceOutput != 'numeric' && parameter.type === 'Regular'">
                                                                <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId" [innerHTML]="parameter.text ||'-'">
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-2">
                                                        <div class="form-group">
                                                            <label class="mb-0"> Unit <code *ngIf="isValidation">*</code></label>
                                                            <h5 class="mt-0 mb-0" *ngIf="parameter.labParameterDetailId" [textContent]="parameter.selected.unitName || '--'">
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-12" *ngIf="parameter.type != 'Regular'">
                                                    <div class=" row col-12 d-flex">
                                                        <div class="form-group col-4">
                                                            <label class="mb-0 text-capitalize text-primary"> {{parameter.parameterName}}</label>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="form-group mb-0 position-relative">
                                                                <ng-select class="ng-select-sm" [items]="labAntibiotics" #ngSelectOption
                                                                           bindLabel="antibioticName"
                                                                           bindValue="antibioticName"
                                                                           typeToSearchText="Search Antibiotic"
                                                                           placeholder="Enter Antibiotic name"
                                                                           (change)="onClickMicroParameter($event ,t,p ,c)" (click)="ngSelectOption.handleClearClick()">
                                                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                                                        No parameter found<span *ngIf="searchTerm"> for '{{searchTerm}}'</span>.
                                                                    </ng-template>
                                                                    <ng-template ng-option-tmp let-item="item" let-i="index">
                                                                        <h5 class="mb-1 mt-0 font-weight-normal" [textContent]="item.antibioticName"></h5>
                                                                    </ng-template>
                                                                </ng-select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row col-12" *ngFor="let antibiotic of parameter.antibiotics;index as j;">
                                                        <div class="row form-group col-12">
                                                            <label class="mb-0 col-4"> {{antibiotic.antibioticName}}</label>
                                                            <select (change)="onChange()" class="form-control custom-select form-control-sm col-4" autocomplete="nope" [(ngModel)]="antibiotic.observedValue">
                                                                <option [ngValue]="null">None</option>
                                                                <option *ngFor="let item of labAntibioticsResultTypes" [textContent]="item.name" [ngValue]="item.name"></option>
                                                            </select>
                                                            <div *ngIf="!antibiotic.labParameterobservedValueId">
                                                                <button type="button" class="btn btn-sm waves-effect waves-light"
                                                                        (click)="removeAntibiotic(parameter,j , t ,p , c)">
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" style="margin-top: -20px !important;" *ngIf="template.isMethod || template.isInterpretation">
                                        <div class="card-box">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="template.isMethod">
                                                    <div class="form-group">
                                                        <label class="mb-1 font-16 font-weight-bold">Method <code *ngIf="isValidation">*</code></label>
                                                        <div>
                                                            <!--<textarea class="form-control" rows="3" placeholder="Enter method text" [(ngModel)]="template.methodText"></textarea>-->
                                                            <ckeditor [editor]="notesEditor" [config]="config" placeholder="Enter method text" (keyup)="onChange()" [(ngModel)]="template.methodText"></ckeditor>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="template.isInterpretation">
                                                    <div class="form-group">
                                                        <label class="mb-1 font-16 font-weight-bold">Interpretation/Result <code *ngIf="isValidation">*</code></label>
                                                        <div>
                                                            <!--<textarea class="form-control" rows="3" placeholder="Enter interpretation text" [(ngModel)]="template.interpretationText"></textarea>-->
                                                            <ckeditor [editor]="notesEditor" (keyup)="onChange()" [config]="config" placeholder="Enter interpretation text" [(ngModel)]="template.interpretationText"></ckeditor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-end">

                                    <span class="badge badge-success mr-1" *ngIf="resultsType !='verifiedReports' && selectedLabBookingDetail && selectedLabBookingDetail.technicianId  && page.userAccount.roleId != 3">Verified by technician</span>
                                    <span class="badge badge-success mr-1" *ngIf="resultsType=='verifiedReports' && page.userAccount.roleId == 3 && doctorDetails">Verified by Doctor</span>

                                    <span>
                                        <button type="button" class="btn btn-sm btn-success mr-1" (click)="onOpenTechForm(templateTechVerify)"
                                                *ngIf="(selectedLabBookingDetail && selectedLabBookingDetail.labBookingStatusId === 6 && selectedLabBookingDetail.technicianId === null &&showTechnitionVerify)">
                                            <i class="mdi mdi-check mr-1"></i> Verify
                                        </button>
                                    </span>
                                    <span>
                                        <button type="button" class="btn btn-sm btn-success mr-1" (click)="onDoctorVerified()"
                                                *ngIf="(!doctorDetails && page.userAccount.roleId == 3) && !showTechnitionVerify && showDoctorVerify">
                                            <i class="mdi mdi-check mr-1"></i> Verify
                                        </button>
                                    </span>
                                    <span>
                                        <button type="button" [disabled]="showButton" (click)="onSubmit()" class="btn btn-sm btn-primary"
                                                *ngIf="((!doctorDetails && page.userAccount.roleId == 3 && resultsType=='verifiedReports') || (selectedLabBookingDetail && selectedLabBookingDetail.technicianId === null))">
                                            <span *ngIf="!submitting">
                                                <i class="mdi mdi-check mr-1"></i>Submit
                                            </span>
                                            <span *ngIf="submitting">
                                                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                Please wait..
                                            </span>

                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="headingStyle">
                        <div class="trapezium font-weight-semibold text-white">
                            <span class="p-1"><i class="mdi mdi-timeline-text-outline me-1"></i> Timeline</span>
                        </div>
                    </div>
                    <div class="card p-2">
                        <div class="row p-2" *ngIf="loadingTimeline">
                            <div class="col-12">
                                <div class="card-box">
                                    <div class="d-flex align-items-center">
                                        <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
                                        <span class="ml-2">Please wait while loading ...</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row p-1" *ngIf="!loadingTimeline && timeline.length === 0">
                            <div class="col-12">
                                <div class="card-box">
                                    <div class="alert alert-warning">
                                        <i class="mdi mdi-alert-octagon-outline mr-1"></i> No record found.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!loadingTimeline && timeline.length > 0">
                            <div>
                                <div class="track-order-list">
                                    <ul class="list-unstyled">
                                        <li class="" *ngFor="let item of timeline; let i = index; let last = last;" [ngClass]="{ 'completed' : !last }">
                                            <span *ngIf="last" class="active-dot dot"></span>
                                            <h5 class="mt-0 mb-1"><span [textContent]="item.status"></span></h5>
                                            <p class="mb-0 mt-0">
                                                <span [textContent]="item.comment"></span>
                                            </p>
                                            <p class="mb-0 mt-0">
                                                <b>By:</b>&nbsp;<span [textContent]="item.commentedByName"></span>&nbsp;at&nbsp;<span class="text-muted">
                                                    <small [textContent]="item.createdDate |date: 'dd-MM-yyyy, hh:mm a'"></small>
                                                </span>&nbsp;&nbsp;
                                                <span [textContent]="item.locationName || '----'"></span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #templateReferenceRange>
    <div class="modal-header d-flex justify-content-between">
        <div>
            <h4 class="modal-title">Lab Parameters Group</h4>
        </div>
        <div>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
        </div>
    </div>
    <div class="modal-body">
        <table class="table table-centered table-sm table-striped table-bordered mb-0 heading1" style="padding:0px !important">
            <thead class="table-user">
                <tr>
                    <th>S.No</th>
                    <th>RangeText</th>
                    <th>Gender</th>
                    <th>FromAge</th>
                    <th>ToAge</th>
                    <th>MinValue</th>
                    <th>MaxValue</th>
                    <th>Min Critical</th>
                    <th>Max Critical</th>
                    <th>Unit</th>
                    <th class="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let group of selectedParameter.allParameterDetail;index as i;">
                    <td>#{{i+1}}</td>
                    <td>
                        <span [textContent]="group.rangeText"></span>
                    </td>
                    <td>
                        <span [textContent]="group.gender"></span>
                    </td>
                    <td>
                        <span [textContent]="group.fromAge"></span>&nbsp;<span [textContent]="group.fromAgeType"></span>
                    </td>
                    <td>
                        <span [textContent]="group.toAge"></span>&nbsp;<span [textContent]="group.toAgeType"></span>
                    </td>
                    <td>
                        <span [textContent]="group.minValue"></span>
                    </td>
                    <td>
                        <span [textContent]="group.maxValue"></span>
                    </td>
                    <td>
                        <span [textContent]="group.minCriticalValue || '--'"></span>
                    </td>
                    <td>
                        <span [textContent]="group.maxCriticalValue || '--'"></span>
                    </td>
                    <td>
                        <span [textContent]="group.unitName || '--'"></span>
                    </td>
                    <td>
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="onSelectParameter(group)"><i class="mdi mdi-check"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #assignDoctor>
    <div class="modal-header">
        <h4 class="modal-title"><i class="mdi mdi-cash mr-1"></i>Doctors</h4>
        <div>
            <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal()">×</button>
        </div>
    </div>
    <div class="modal-body" *ngIf="loadingProviders">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while Provider details....</span>
        </div>
    </div>
    <div class="modal-body" *ngIf="provideredit">
        <div>
            <table class="table table-centered table-bordered table-sm mb-0">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Assigned To</th>
                        <th>Result</th>
                        <th *ngIf="doctorDropDown">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let provider of providerAssigned;index as p;">
                        <td><h6 class="mb-0 mt-0" [textContent]="p+1"></h6></td>
                        <td> <h6 class="mb-0 mt-0" [textContent]="provider.providerName"></h6></td>
                        <td><h6>{{provider.approved ? "Verified" : "NotVerified"}}</h6></td>
                        <td *ngIf="!provider.approved">
                            <button class="btn btn-sm btn-outline-danger" (click)="onDeleteAssignedDoctor(provider)"><i class="mdi mdi-close mr-1"></i> Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-body" *ngIf="!loadingProviders && doctorDropDown">
        <div>
            <form [formGroup]="providerAssigningForm" (ngSubmit)="assignDoctors()">
                <div class="col-12 mb-2">
                    <div>
                        <ng-select [items]="providers"
                                   [loading]="loadingproviderAssigning"
                                   [clearable]="!provideredit"
                                   bindLabel="value"
                                   bindValue="id"
                                   [searchFn]="customSearch"
                                   placeholder="Enter Doctor Name/Department Name"
                                   (search)="fetchDoctorSpecializationHelper($event)"
                                   [multiple]="true"
                                   (change)="onChangeProvider($event)"
                                   [ngClass]="{ 'is-invalid': (submitted && forms.providerSchedule.approvedBy.errors) }"
                                   (remove)="onRemove($event)"
                                   formControlName="approvedBy">
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                <div class="ng-option disabled" *ngIf="searchTerm && searchTerm.length >= 2">
                                    No Doctor found for '{{searchTerm}}'
                                </div>
                                <div class="ng-option disabled" *ngIf="(!searchTerm || searchTerm.length < 2)">
                                    Search Doctor
                                </div>
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item" let-i="index">
                                <div class="media">
                                    <div class="avatar-xs mr-1">
                                        <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary"><i class="fe-map-pin"></i></span>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="mb-0 mt-0 font-weight-normal" [textContent]="item.value"></h5>
                                        <span class="d-block font-13" [textContent]="item.optionalText || '-----'"></span>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm mr-1" (click)="onCloseModal();">Cancel</button>
                    <button type="submit" [disabled]="submitting" class="btn btn-primary btn-sm">
                        <span *ngIf="submitting">
                            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Please wait..
                        </span>
                        <span *ngIf="!submitting">Submit</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>


<ng-template #showPreviousResults>
    <div class="modal-header">
        <h4 class="modal-title"><i class="mdi mdi-cash mr-1"></i>Amendment's </h4>
        <div>
            <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal()">×</button>
        </div>
    </div>
    <div class="modal-body" *ngIf="loadingObservedValues">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while Provider details....</span>
        </div>
    </div>
    <div class="modal-body">
        <div>
            <h5 class="badge badge-outline-primary"> <i class="mdi mdi-information mr-1 text-primary "></i>The Final result will Appear on Right side of screen </h5>
        </div>
        <div class="d-flex border font-15 font-weight-bold" *ngIf="!loadingObservedValues">
            <div class="p-1">
                <div *ngFor="let i of parameterNames" class="p-1 white-space-nowrap border-bottom">
                    {{i.parameterName}}
                </div>
                <br />
                <div>UpdatedBy</div>
            </div>

            <div class="overflow-auto d-flex flex-grow-1 pr-1" *ngIf="totalObservedValues2">
                <div *ngFor="let item of totalObservedValues2.slice().reverse() " class="border-left flex-grow-1 p-1">
                    <div class="flex-grow-1" [ngClass]="{'text-success':item[0].active}">
                        <div *ngFor="let each of item" class="p-1 border-bottom">
                            <div [ngStyle]="{'color': each.isChanged ? '#ff0000':'#000000'}">
                                {{each.observedValue || '--'}}
                            </div>

                        </div>
                        <br />
                        <span class="white-space-nowrap"><i [ngClass]="{'text-success':item[0].active}" class="mdi mdi-account text-primary mr-1"></i>{{item[0].createdByName}}</span>
                        <br />
                        <div class="white-space-nowrap"><i [ngClass]="{'text-success':item[0].active}" class="mdi mdi-calendar text-primary mr-1"></i><small class="white-space-nowrap" [textContent]="item[0].createdDate |date: 'dd-MM-yyyy'"></small></div>
                        <div class="white-space-nowrap"><i [ngClass]="{'text-success':item[0].active}" class="mdi mdi-clock text-primary mr-1"></i><small [textContent]="item[0].createdDate |date: 'hh:mm a'"></small></div>
                        <h5 class="badge badge-outline-success" *ngIf="item[0].active">ActiveResult</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>

<ng-template #templateLabReport>
    <div class="modal-header" *ngIf="showLabReport">
        <h4 class="modal-title"><i class="mdi mdi-cash mr-1"></i>Lab Report</h4>
        <div>
            <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal()">×</button>
        </div>
    </div>
    <interim-report [encryptedNewLabBookingDetailId]="encryptedNewLabBookingDetailId" (onClose)="onCloseExtraPopup()"></interim-report>
    
</ng-template>


<ng-template #templateTechVerify>
    <div *ngIf="showLabReport">
        <form [formGroup]="techForm" (ngSubmit)="onSubmitVerify()">
            <div class="modal-header">
                <h4 class="modal-title"><i class="mdi mdi-check mr-1"></i>Verification</h4>
                <div>
                    <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal()">×</button>
                </div>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Approval Comment <code>*</code></label>
                    <div>
                        <ckeditor [editor]="notesEditor" [config]="config" placeholder="Enter approving comment here" formControlName="technicianComment"></ckeditor>
                    </div>
                    <div class="text-danger show-must" *ngIf="submitted && forms.tech.technicianComment.errors">
                        <p *ngIf="forms.tech.technicianComment.errors.required">This field is required.</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light btn-sm mr-1" (click)="onCloseModal();">Cancel</button>
                <button type="submit" [disabled]="submitting" class="btn btn-primary btn-sm">
                    <span *ngIf="submitting">
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Please wait..
                    </span>
                    <span *ngIf="!submitting">Submit</span>
                </button>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #templateViewReport>
    <div class="modal-header">
        <h4 class="modal-title"><i class="mdi mdi-upload mr-1"></i>View Document</h4>
        <div>
            <button class="btn btn-outline-danger mr-1" (click)="onDeleteDocument()">
                <i class="mdi mdi-delete-variant"></i> Delete
            </button>
            <button class="btn btn-light btn-xs mr-1 d-print-none" placement="right" type="button" (click)="onPrintPdf()"><i placement="right" class="mdi mdi-printer mr-1"></i> print</button>
            <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal()">×</button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12" *ngIf="!loadingFile && !formedUrl">
                <div class="form-group mb-1">
                    <p class="text-justify font-weight-bold" style="box-sizing:border-box"></p>
                </div>
            </div>
        </div>
    </div>
    <div class="heading1 pl-1 pr-1">
        <pdf-viewer [src]="reportData['changingThisBreaksApplicationSecurity']"
                    [render-text]="true"
                    [autoresize]="true"
                    [original-size]="false"
                    [fit-to-page]="false"
                    (on-progress)="onProgress($event)"
                    style="width: 100%; height: 500px">
        </pdf-viewer>
    </div>
</ng-template>

<ng-template #templateMultipleUploadDocument>
    <form [formGroup]="uploadForm" (ngSubmit)="onUploadDocument()">
        <div class="modal-header">
            <h4 class="modal-title"><i class="mdi mdi-file-multiple mr-1"></i>Upload Documents</h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onMutipleDocumetCloseModel()">×</button>
        </div>
        <div class="modal-body">
            <div class="row appointment-form bg-pattern bg-light mb-3">
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="mb-1">Document Name <code>*</code></label>
                        <input type="text" autofocus formControlName="documentName" maxlength="100" block autocomplete="nope" class="form-control" placeholder="Enter document name" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group mb-0">
                        <label class="mb-1">Description</label>
                        <textarea rows="1" cols="20" formControlName="description" block maxlength="250" autocomplete="nope" class="form-control" placeholder="Enter document description"></textarea>
                    </div>
                </div>
            </div>
            <file-dropper [expandable]="true"
                          [maxFiles]="maxFiles"
                          [maxFileSize]="10000"
                          [accept]="'application/pdf,image/jpeg, image/pjpeg, image/png, image/gif,video/mp4'"
                          (onSelectEmitter)="onFileSelect($event)">
            </file-dropper>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default btn-sm" (click)="onCloseModal();">Cancel</button>
            <button type="submit" [disabled]="submitting" class="btn btn-primary btn-sm ml-1">
                <span *ngIf="submitting">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                    Please wait..
                </span>
                <span *ngIf="!submitting">Upload Document</span>
            </button>
        </div>
    </form>
</ng-template>

<ng-template #templateUploadDocument>
    <div class="modal-header">
        <h4 class="modal-title"><i class="mdi mdi-upload mr-1"></i>View Document and Upload Document</h4>
        <button type="button" class="closeBtn" data-dismiss="modal" aria-hidden="true" (click)="onCloseModalView()">×</button>
    </div>
    <div class="row">
        <div class="modifying-content" *ngIf="modifying">
            <p>Please wait while {{modifyingContent}}.</p>
        </div>
        <div class="col-lg-4 mb-3" *ngFor="let item of documents">
            <div class="document-container">
                <div class="document-thumbnail">
                    <a href="javascript:;" (click)="onOpenModalView(templateViewDocument,item)"><img src="assets/images/documentImage1.png" [alt]="item.documentName" /></a>
                </div>
                <div class="document-body">
                    <h4><a href="javascript:;" (click)="onOpenModalView(templateViewDocument,item)" class="text-dark" [textContent]="item.documentName"></a></h4>
                    <h6 [textContent]="item.documentType"></h6>
                    <p class="text-lowercase"><span [textContent]="item.size | formatBytes"></span> - <span class="text-primary" [textContent]="item.uploadedDate | date:'dd-MM-yyyy hh:mm a'"></span></p>
                </div>
                <div class="document-actions">
                    <div *ngIf="item.uploadedBy === page.userAccount.accountId">
                        <a href="javascript:;" placement="left" ngbTooltip="Delete" (click)="onDelete(item)"><i class="mdi mdi-trash-can-outline"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mh-300">
            <div class="no-data">
                <button class="btn btn-sm btn-outline-primary"
                        (click)="onOpenModalMultiple(templateMultipleUploadDocument)">
                    Upload Document
                </button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #templateViewDocument>
    <div class="modal-header">
        <h4 class="modal-title"><span [textContent]="document.documentName"></span></h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
    </div>
    <div class="modal-body">
        <a href="javascript:;" (click)="onPrevious()" class="previous-document" placement="left" ngbTooltip="Previous document" *ngIf="showPrevious"><i class="mdi mdi-arrow-left-bold"></i></a>
        <a href="javascript:;" (click)="onNext()" class="next-document" placement="left" ngbTooltip="Next document" *ngIf="showNext"><i class="mdi mdi-arrow-right-bold"></i></a>
        <div class="p-3" *ngIf="loadingDocument">
            <div class="d-flex align-items-center">
                <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                <span class="ml-3">Please wait while loading Document ...</span>
            </div>
        </div>
        <div *ngIf="!loadingDocument && documentError">
            <div class="position-relative mh-300">
                <no-data title="Document"></no-data>
            </div>
        </div>
        <ng-container *ngIf="document && document.isImage">
            <img [src]="document.formedUrl" [hidden]="loadingDocument || documentError" (load)="onDocumentLoad()" (error)="onDocumentError()" [alt]="document.documentName" />
        </ng-container>
        <ng-container *ngIf="document && document.isVideo">
            <video style="width: 100%; height: 100%" controls (click)="toggleVideo()" #videoPlayer autoplay>
                <source [src]="document.formedUrl" (load)="onDocumentLoad()" [type]="document.contentType">
            </video>
        </ng-container>
        <ng-container *ngIf="document && !document.isImage && !document.isVideo">
            <ng-container *ngIf="document && document.formedUrl">
                <pdf-viewer [src]="document.formedUrl['changingThisBreaksApplicationSecurity']"
                            [render-text]="true"
                            [autoresize]="true"
                            [original-size]="false"
                            [fit-to-page]="false"
                            (on-progress)="onProgress($event)"
                            (error)="onDocumentError()"
                            style="width: 100%; height: 500px">
                </pdf-viewer>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
<ng-template #templateShowPastReports>
    <div class="modal-header d-flex justify-content-between">
        <div>
            <h4 class="modal-title">Past Lab Reports</h4>
        </div>
        <div>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row p-2" *ngIf="loadingPastLabReports">
            <div class="col-12">
                <div class="d-flex align-items-center">
                    <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
                    <span class="ml-2">Please wait while loading ...</span>
                </div>
            </div>
        </div>
        <div class="row p-1" *ngIf="!loadingPastLabReports && (!patientPastLabReports || !patientPastLabReports.length)">
            <div class="col-12 mh-300">
                <no-data [applied]="false" [title]="'Past Tests'"></no-data>
            </div>
        </div>
        <div class="col-12">
            <div class="card-box p-0 overflow-auto">
                <table class="table table-sm table-bordered" *ngIf="!loadingPastLabReports && patientPastLabReports.length > 0">
                    <thead class=" ">
                        <tr>
                            <th>Test Name </th>
                            <th>TypeOfLab</th>
                            <th>BookedDate</th>
                            <th>Status</th>
                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let item of patientPastLabReports;index as i;">
                            <td>
                                <h5 class="mb-0 mt-0 font-weight-normal" [textContent]="item.testName"></h5>
                                <small class="d-block" [textContent]="item.testCode || '--'"></small>
                            </td>
                            <td>
                                <span class="badge badge-success" *ngIf="item.isInternalLab">Internal</span>
                                <span class="badge badge-secondary" *ngIf="item.isExternalLab">External</span>
                            </td>
                            <td>
                                <span [textContent]="item.createdDate | date:'dd-MM-yyyy, hh:mm a'"></span>
                            </td>
                            <td>
                                <span class="badge badge-outline-secondary" [textContent]="item.status"></span>
                            </td>
                            <td>
                                <button type="button" placement="left" ngbTooltip="View Report" class="btn mt-1 btn-sm btn-outline-info" (click)="onOpenLAbReport(item)">
                                    <i class="mdi mdi-eye mr-1"></i> View Report
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5">
                                <nav class="d-flex align-items-center justify-content-between flex-wrap">
                                    <p class="mb-0 font-13">
                                        <span class="text-dark">Page <span [textContent]="pagination1.currentPage"></span> of <span [textContent]="pagination1.totalPages"></span></span>
                                        <span class="ml-1">
                                            <span>(Showing <span [textContent]="pagination1.currentItems - patientPastLabReports.length + 1"></span> - <span [textContent]="pagination1.currentItems"></span> of <span [textContent]="pagination1.totalItems"></span> records)</span>
                                        </span>
                                    </p>
                                    <ngb-pagination class="pagination justify-content-end" [maxSize]="5" [rotate]="false" [ellipses]="false" [(page)]="pagination1.pageIndex" [pageSize]="pagination1.pageSize" (pageChange)="onNextTemplatePage()" [collectionSize]="pagination1.totalItems">
                                        <ng-template ngbPaginationPrevious><i class="fe-arrow-left"></i></ng-template>
                                        <ng-template ngbPaginationNext><i class="fe-arrow-right"></i></ng-template>
                                    </ngb-pagination>
                                </nav>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #templateReason>
    <div class="center-position">
        <div class="modal-header">
            <h4 class="modal-title"><span [textContent]="'Reason'"></span></h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseReasonView();">×</button>
        </div>
        <div class="modal-body">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="mb-1">Reason <code>*</code></label>
                    <input type="text" class="form-control" [(ngModel)]="reason" placeholder="Enter Reason">
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button class="btn btn-sm btn-primary"
                    (click)="onRemoveParameters()">
                Submit
            </button>
        </div>
    </div>
</ng-template>
